<div class="account__container">
  @if (profile(); as p) {
    <app-konto-profilkopf [profil]="p" />
  } @else if (profileLoading()) {
    <div class="account__loading">
      <mat-progress-spinner mode="indeterminate" diameter="40" />
    </div>
  } @else if (profileError()) {
    <div class="account__ladefehler" data-testid="konto-ladefehler" role="alert">
      <p class="account__ladefehler-text">{{ 'account.profileLoadError' | translate }}</p>
      <button type="button" mat-stroked-button data-testid="konto-erneut" (click)="loadProfile()">
        {{ 'common.retry' | translate }}
      </button>
    </div>
  }

  <app-konto-reiter [aktiv]="reiter()" [fehlend]="providerTokenStatus.fehlend()" (gewaehlt)="reiterWaehlen($event)" />

  <div
    class="account__panel"
    role="tabpanel"
    id="konto-panel-profil"
    aria-labelledby="konto-tab-profil"
    [hidden]="reiter() !== 'profil'"
  >
    <app-benachrichtigungen-karte #benachrichtigungen id="benachrichtigungen" />
  </div>

  <div
    class="account__panel"
    role="tabpanel"
    id="konto-panel-integrationen"
    aria-labelledby="konto-tab-integrationen"
    [hidden]="reiter() !== 'integrationen'"
  >
    <app-konto-sektion
      [titel]="'providerTokens.section.title' | translate"
      [untertitel]="'providerTokens.section.subtitle' | translate"
    >
      <app-provider-tokens-section [fokusHost]="tokenHost()" />
    </app-konto-sektion>

    @if (profile(); as p) {
      <app-konto-sektion
        [titel]="'githubToken.section.title' | translate"
        [untertitel]="'githubToken.section.subtitle' | translate"
      >
        <app-github-token-section [hasToken]="p.hasGithubToken" />
      </app-konto-sektion>
    }

    <app-ki-mcp-block />
  </div>

  <div
    class="account__panel"
    role="tabpanel"
    id="konto-panel-api"
    aria-labelledby="konto-tab-api"
    [hidden]="reiter() !== 'api'"
  >
    <app-konto-api-tokens />
  </div>
</div>
